/**
 * Formats a date/time for display in the runtime default locale and the user's
 * local timezone, with minutes (no seconds) and a short timezone label.
 *
 * Do not combine `dateStyle` / `timeStyle` with `timeZoneName` in a single options
 * object — that throws in several engines (“Invalid option” / RangeError).
 */
export function formatLocalizedDateTimeWithShortTz(
  value: Date | number | string
): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new Error(
      `Invalid date for formatLocalizedDateTimeWithShortTz: ${String(value)}`
    );
  }

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}
